import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ProductBundleOptionsComponentDef } from '@df/catalog-ui/product/bundle-options/product-bundle-options.component.def';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';

/**
 *
 *
 * ## Usage (from any product component)
 *
 * ```html
 * <product-bundle-options [product]="model"
 *      [buyRequest]="request.bundle_options"></product-bundle-options>
 * ````
 */
@Component({
    selector: 'product-bundle-options',
    templateUrl: './product-bundle-options.html',
    standalone: true,
    imports: [CommonModule, TranslatePipe],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductBundleOptionsComponent extends ProductBundleOptionsComponentDef {}
